export enum Roles {
  Doctor = 'doctor',
  NursePractitioner = 'nursePractitioner',
  PharmD = 'pharmD',
  PhysicianAssistant = 'physicianAssistant',
  QHCP = 'QHCP',
  RegisteredNurse = 'registeredNurse',

  ClientSuccessOnboarding = 'clientSuccessOnboarding',
  ClientSuccessScaling = 'clientSuccessScaling',
  ClientSuccessRepresentative = 'clientSuccessRepresentative',
  SalesRepresentative = 'salesRepresentative',

  AdminPanelAccess = 'admin-panel-access',
  AdminTools = 'adminTools',
  Biller = 'biller',
  BillingTools = 'billingTools',

  MedicalAssistant = 'medicalAssistant',
  AtRiskAlerting = 'atRiskAlerting',
  CriticalAlerting = 'criticalAlerting',
  Default = 'default',
  Nutritionist = 'nutritionist',
  Onboarding = 'onboarding',
  PatientAcceptance = 'patientAcceptance',
  CallDashboard = 'callDashboard',
  Supervisor = 'supervisor',
  CallAgent = 'call-agent',
  SmsDashboard = 'smsDashboard',
  SmsDashboardUnregistered = 'smsDashboardUnregistered',
  Support = 'support',
  Clinical = 'clinical',
  Turk = 'turk',
  CallManager = 'callManager',
}

export enum ReadingTemplateRoles {
  RegisterNurse = 'register-nurse',
  MedicalAssistant = 'medical-assistant',
}
